import { render } from "./AddForm.vue?vue&type=template&id=25626dce&scoped=true"
import script from "./AddForm.vue?vue&type=script&lang=js"
export * from "./AddForm.vue?vue&type=script&lang=js"

import "./AddForm.vue?vue&type=style&index=0&id=25626dce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25626dce"]])

export default __exports__